import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import SelectField from 'modules/core/components/SelectField'
import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { employeeJob } from 'modules/job_catalog/store/collections/roles'

interface Props {
  user: User
  contractVersions: ContractVersions
}

function Owner({ user, contractVersions }: Props) {
  const fullName = user.fullName()
  const dummyValue = 'owner'
  const job: string =
    (user.employee && employeeJob(contractVersions, user.employee)) || user.email || '-'
  const option = [
    {
      label: i18n.t('custom_reports.share.modal.owner'),
      value: dummyValue,
    },
  ]

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="flexStart">
      <UserAvatar user={user} size="s32" />
      <Box minWidth="none" paddingLeft="s8" paddingRight="s16" flexGrow>
        <Text size="300" weight="medium" color="grey1000" ellipsis>
          {fullName}
        </Text>
        <Text size="200" weight="normal" ellipsis>
          {job}
        </Text>
      </Box>
      <Box width="s140" flexGrow={false} flexNoShrink maxWidth="s140">
        <SelectField options={option} value={dummyValue} readonly />
      </Box>
    </Box>
  )
}

export default observer(Owner)
